var searchData = JSON.parse(JSON.stringify(courses));
var filters = { "search": "", "credit_units": [], "course_category_id": [], "cert_prep": [] };

function debounce(func, timeout = 300) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

const processChange = debounce(() => searchInput());

function searchInput() {
  filters.search = document.getElementById('searchInput').value.toLowerCase();
  filterResult();
}

function isMobile() {
  return window.innerWidth <= 799;
}

function buildResult(data) {
  let content = '';
  data.forEach(function (course, index) {
    content += `<div class="course-item" data-index="${index}">${buildCourseHTML(course, index)}</div>`;
  });
  document.getElementById("courseList").innerHTML = content;
  var courseCountElement = document.querySelector("h2.title span");
  if (courseCountElement) {
    courseCountElement.innerText = data.length;
  }
  setInitialButtonText();
}

function buildCourseHTML(course, index) {
  return `
    <div class="top-buttons">
      <button class="show-details">Hide Details</button>
      <button class="accordion active">
        ${course.name}
        <span class="credit-units">${
          course.ce_accreditation.credit_units != null
            ? `${course.ce_accreditation.credit_units} credit unit(s)`
            : ""
        }</span>
      </button>
    </div>
    <div class="panel accordion-visible">
      ${buildTabs(course, index)}
    </div>
  `;
}

function buildTabs(course, index) {
  let tabsHTML = '';
  let desktopTabs = [];
  if (course.description)
    desktopTabs.push({ id: `angebot-${index}-1`, label: 'Course Overview', content: course.description });
  if (course.learning_objectives_html)
    desktopTabs.push({ id: `angebot-${index}-2`, label: 'Learning Objectives', content: course.learning_objectives_html });
  if (course.author_information)
    desktopTabs.push({ id: `angebot-${index}-3`, label: 'Author Information', content: course.author_information });
  if (course.course_outline_html)
    desktopTabs.push({ id: `angebot-${index}-4`, label: 'Course Outline', content: course.course_outline_html });
  if (course.ce_accreditation.accrediting_body_name) {
    let creditInfoContent = `
      <div><strong>Accrediting Body</strong>: ${course.ce_accreditation.accrediting_body_name}</div>
      ${
        course.ce_accreditation.credit_display_name
          ? `<div><strong>Credit Name</strong>: ${course.ce_accreditation.credit_display_name}<br><strong>Credit Units</strong>: ${course.ce_accreditation.credit_units} ${course.ce_accreditation.credit_unit_display_name}</div>`
          : ''
      }
      ${
        course.ce_accreditation.course_level_accreditation_statement || course.ce_accreditation.accreditation_statement
          ? `
            <div><strong>Accreditation Statement</strong>:</div>
            ${course.ce_accreditation.course_level_accreditation_statement ? `<div>${course.ce_accreditation.course_level_accreditation_statement}</div>` : ''}
            ${course.ce_accreditation.accreditation_statement ? `<div>${course.ce_accreditation.accreditation_statement}</div>` : ''}
          `
          : ''
      }
    `;
    desktopTabs.push({ id: `angebot-${index}-5`, label: 'Credit Info', content: creditInfoContent });
  }
  if (desktopTabs.length > 0) {
    tabsHTML += `<div class="tab nomob">`;
    desktopTabs.forEach((tab, i) => {
      tabsHTML += `<button class="tablinks nomob${i === 0 ? ' active' : ''}" data-tab-id="${tab.id}">${tab.label}</button>`;
    });
    tabsHTML += `</div><div class="tabcontents nomob">`;
    desktopTabs.forEach((tab, i) => {
      tabsHTML += `<div id="${tab.id}" class="tabcontent${i === 0 ? ' active' : ''}">${tab.content}</div>`;
    });
    tabsHTML += `</div>`;
  }
  if (desktopTabs.length > 0) {
    tabsHTML += `<div class="tab nodesktop">`;
    desktopTabs.forEach((tab, i) => {
      tabsHTML += `
        <button type="button" class="tablinks nodesktop${i === 0 ? ' active' : ''}" data-tab-id="${tab.id}">
          ${tab.label} <span class="indicator"></span>
        </button>
        <div id="${tab.id}" class="tabcontent${i === 0 ? ' active' : ' hidden'}">${tab.content}</div>
      `;
    });
    tabsHTML += `</div>`;
  }
  return tabsHTML;
}

function setInitialButtonText() {
  var showDetailsButtons = document.querySelectorAll(".show-details");
  showDetailsButtons.forEach(function (button) {
    var panel = button.closest('.top-buttons').nextElementSibling;
    if (panel && panel.classList.contains("accordion-visible")) {
      button.textContent = isMobile() ? "Close" : "Hide Details";
    } else {
      button.textContent = isMobile() ? "Details" : "Show Details";
    }
  });
}

function adjustTabContentHeight() {
  const tabContents = document.querySelectorAll(".tabcontent.active");
  tabContents.forEach(tabContent => {
    if (isMobile()) {
      if (tabContent.scrollHeight > 360) {
        tabContent.style.maxHeight = "360px";
        tabContent.style.overflowY = "scroll";
      } else {
        tabContent.style.maxHeight = "";
        tabContent.style.overflowY = "auto";
      }
    } else {
      if (tabContent.scrollHeight > 500) {
        tabContent.style.maxHeight = "500px";
        tabContent.style.overflowY = "scroll";
      } else {
        tabContent.style.maxHeight = "";
        tabContent.style.overflowY = "auto";
      }
    }
  });
}

function toggleAccordion(accordionButton, accordionPanel, showDetailsButton) {
  var isVisible = accordionPanel.classList.contains("accordion-visible");
  if (isVisible) {
    accordionPanel.classList.remove("accordion-visible");
    accordionButton.classList.remove("active");
    showDetailsButton.textContent = isMobile() ? "Details" : "Show Details";
  } else {
    accordionPanel.classList.add("accordion-visible");
    accordionButton.classList.add("active");
    showDetailsButton.textContent = isMobile() ? "Close" : "Hide Details";
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const urlParams = new URLSearchParams(window.location.search);
  const urlVariantId = urlParams.get('variant');
  if (urlVariantId) {
    document.dispatchEvent(new CustomEvent('variantChanged', { detail: { variantId: urlVariantId } }));
  } else {
    buildResult(courses);
  }
  window.addEventListener('resize', debounce(setInitialButtonText, 300));
  const courseList = document.getElementById('courseList');
  if (courseList) {
    courseList.addEventListener('click', handleCourseListClick);
  }
  document.addEventListener('variantChanged', handleVariantChange);
});

function handleCourseListClick(event) {
  const target = event.target;
  const courseItem = target.closest('.course-item');
  if (!courseItem) return;
  if (target.closest('.show-details')) {
    handleShowDetailsClick(courseItem);
  } else if (target.closest('.accordion')) {
    handleAccordionClick(courseItem);
  } else if (target.closest('.tablinks.nodesktop')) {
    handleMobileTabClick(event, courseItem);
  } else if (target.closest('.tablinks.nomob')) {
    handleDesktopTabClick(event, courseItem);
  }
}

function handleShowDetailsClick(courseItem) {
  const panel = courseItem.querySelector('.panel');
  const accordionButton = courseItem.querySelector('.accordion');
  const showDetailsButton = courseItem.querySelector('.show-details');
  toggleAccordion(accordionButton, panel, showDetailsButton);
}

function handleAccordionClick(courseItem) {
  const panel = courseItem.querySelector('.panel');
  const accordionButton = courseItem.querySelector('.accordion');
  const showDetailsButton = courseItem.querySelector('.show-details');
  toggleAccordion(accordionButton, panel, showDetailsButton);
}

function handleMobileTabClick(event, courseItem) {
  event.preventDefault();
  const tabLink = event.target.closest('.tablinks.nodesktop');
  const tabId = tabLink.getAttribute('data-tab-id');
  const tabContent = tabLink.nextElementSibling;
  const isActive = tabLink.classList.contains('active');
  const tabLinks = courseItem.querySelectorAll('.tab.nodesktop .tablinks');
  const tabContents = courseItem.querySelectorAll('.tab.nodesktop .tabcontent');
  tabLinks.forEach(link => link.classList.remove('active'));
  tabContents.forEach(content => {
    content.classList.remove('active');
    content.classList.add('hidden');
  });
  if (!isActive) {
    tabLink.classList.add('active');
    tabContent.classList.add('active');
    tabContent.classList.remove('hidden');
  }
  adjustTabContentHeight();
}

function handleDesktopTabClick(event, courseItem) {
  event.preventDefault();
  const tabLink = event.target.closest('.tablinks.nomob');
  const tabId = tabLink.getAttribute('data-tab-id');
  const tabLinks = courseItem.querySelectorAll('.tab.nomob .tablinks');
  const tabContents = courseItem.querySelectorAll('.tabcontents.nomob .tabcontent');
  tabLinks.forEach(link => link.classList.remove('active'));
  tabContents.forEach(content => {
    content.classList.remove('active');
    content.classList.add('hidden');
  });
  tabLink.classList.add('active');
  const activeContent = courseItem.querySelector(`.tabcontents.nomob .tabcontent#${tabId}`);
  if (activeContent) {
    activeContent.classList.add('active');
    activeContent.classList.remove('hidden');
  }
  adjustTabContentHeight();
}

async function handleVariantChange(event) {
  const variantId = event.detail.variantId;
  const variantSku = window.variantCourseMap ? window.variantCourseMap[variantId] : null;
  if (variantSku) {
    const courseJsonUrl = `/cdn/shop/t/42/assets/courses_${variantSku}.js`;
    try {
      window.courses = null;
      searchData = [];
      document.getElementById("courseList").innerHTML = "";
      const response = await fetch(courseJsonUrl);
      const text = await response.text();
      window.eval(text);
      if (typeof courses !== 'undefined') {
        window.courses = courses;
      }
      if (window.courses && Array.isArray(window.courses)) {
        if (window.courses.length && window.courses[0].course_type === 32) {
          searchData = JSON.parse(JSON.stringify(window.courses))
            .filter(course => course.course_type === 32)
            .flatMap(course => course.sub_courses)
            .filter(subCourse => !subCourse.name.startsWith("A Guide to"));
        } else {
          searchData = JSON.parse(JSON.stringify(window.courses));
        }
        document.getElementById("courseList").innerHTML = "";
        buildResult(searchData);
      } else {
        setTimeout(() => handleVariantChange(event), 500);
      }
    } catch (error) {
      // Error handling removed.
    }
  }
}